import * as types from '../constants'
import { Record } from 'immutable'

const commonsRecord = Record({
  message: '',
  isError: false,
  showSignIn: false,
  pageType: 'adcouncil',
})

const initialState = new commonsRecord()

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_FLASH_MESSAGE: {
      return state.merge({ message: action.msg, isError: action.isError })
    }
    case types.HIDE_FLASH_MESSAGE: {
      return state.merge({ message: '', isError: false })
    }
    case types.UPDATE_PAGE_TYPE: {
      return state.set('pageType', action.pageType)
    }
    case types.SHOW_SIGNIN_MODAL: {
      return state.merge({ showSignIn: action.showSignIn })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/common.js